import {createSlice} from "@reduxjs/toolkit";
import System from "src/helper/system";

const storage_name = 'ProductListingFilterBoxSelection' + '__' + System.getCurrentSiteSpeedboat();

let l = localStorage.getItem(storage_name)
if (l) {
    l = JSON.parse(l);
} else {
    l = {}
}

const defaultSelectionCantBeRemoved = {
    "Categories": {"slug": "Categories", "main_label": "Category"},
    "ManufacturerName": {"slug": "ManufacturerName", "main_label": "Manufacturer"},
    "FamilyName": {"slug": "FamilyName", "main_label": "Product Family"}
};

const setAllToLocalStorage = (data) => {
    data = JSON.parse(JSON.stringify(data))
    data = {...data, ...defaultSelectionCantBeRemoved}
    localStorage.setItem(storage_name, JSON.stringify(data))
};

const slice = createSlice({
        name: "ProductListingFilterBoxSelection",
        initialState: {...l, ...defaultSelectionCantBeRemoved},
        reducers: {
            loadData: {
                reducer: (state, action) => {
                    state = {...defaultSelectionCantBeRemoved, ...action.payload.data};
                    setAllToLocalStorage(state)
                    return state;
                },
            },
            updateSmartly: {
                reducer: (state, action) => {
                    if (action.payload.status === true) {
                        state[action.payload.selection.slug] = action.payload.selection;
                    }
                    if (action.payload.status === false) {
                        delete state[action.payload.selection.slug];
                    }
                    setAllToLocalStorage(state)
                    return state;
                },
            }
        }
    })
;

export let {loadData, updateSmartly} = slice.actions;

export default slice.reducer;
